import React, { Suspense, lazy, useState } from 'react';

import { ErrorBoundary } from 'react-error-boundary';

import { TriggerLink } from '../../TriggerLink';
import { SpecsAndTemplatesData } from '../types';

const SpecsAndTemplatesModalView = lazy(() =>
  import('./SpecsAndTemplatesModalView').then((m) => ({ default: m.SpecsAndTemplatesModalView }))
);

export interface SpecsAndTemplatesProps {
  productKey: string;
  productVersion: number;
  isAuthInitialized: boolean;
  authHeader?: string;
  locale: string;
  data: SpecsAndTemplatesData;
  requestor: string;
  onFileDownload?: (fileTypeDownloaded: string) => void;
  onErrorCallback?: (error: Error) => void;
  trigger: React.ReactNode;
  mpvId: string;
}

export const SpecsAndTemplates = (props: SpecsAndTemplatesProps) => {
  const { isAuthInitialized, authHeader, locale, onFileDownload, onErrorCallback } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const isInitialized = isAuthInitialized && authHeader;
  const handleTriggerOnClick = () => isInitialized && setIsModalOpen(true);

  return (
    shouldRender(props) && (
      <>
        <TriggerLink onTriggerOnClick={handleTriggerOnClick} trigger={props.trigger} />
        {isModalOpen && isInitialized && (
          <ErrorBoundary fallback={null} onError={() => setIsModalOpen(false)}>
            <Suspense fallback={null}>
              <SpecsAndTemplatesModalView
                authHeader={authHeader}
                culture={locale}
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onFileDownload={onFileDownload}
                onErrorCallback={onErrorCallback}
                data={props.data}
                requestor={props.requestor}
                mpv={{
                  mpvId: props.mpvId,
                  coreProductId: props.productKey,
                  version: props.productVersion,
                }}
              />
            </Suspense>
          </ErrorBoundary>
        )}
      </>
    )
  );
};

export const shouldRender = (props: Partial<Pick<SpecsAndTemplatesProps, 'data'>>): boolean => {
  return !!props.data?.isEnabled;
};
